import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Radio, Box } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { formatDataTestId } from '../../utils/formatters';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var RadioCard = forwardRef((_ref, ref) => {
  var header = _ref.header,
    isChecked = _ref.isChecked,
    value = _ref.value,
    onClick = _ref.onClick,
    children = _ref.children,
    isClassChecked = _ref.isClassChecked;
  var baseDataTestId = 'RadioCard';
  return _jsxs(Box, _objectSpread(_objectSpread(_objectSpread({}, radioCardBoxStyle), isChecked ? {
    borderColor: 'darkPurple',
    boxShadow: '0px 5.23px 6.28px 0px #00000005',
    cursor: 'default'
  } : {
    borderColor: 'lightGrey3',
    boxShadow: undefined,
    cursor: 'pointer'
  }), {}, {
    "data-testid": formatDataTestId(baseDataTestId, 'Wrapper'),
    ref: ref,
    onClick: onClick,
    children: [_jsxs(Box, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, headerBoxStyle), {}, {
      background: isChecked ? 'darkPurple' : isClassChecked ? 'lightPurple2' : 'lightGrey5'
    })), {}, {
      children: [_jsx(Radio, {
        value: value,
        isChecked: isChecked,
        size: "lg",
        variant: "softBundle"
      }), header]
    })), _jsx(Box, _objectSpread(_objectSpread({}, contentBoxStyle), {}, {
      children: children
    }))]
  }));
});
RadioCard.displayName = 'RadioCard';
var radioCardBoxStyle = {
  border: '1px solid',
  borderRadius: 4,
  position: 'sticky',
  minW: {
    mobile: '13.188rem',
    xs: '16.25rem',
    sm: '13.35rem',
    md: 'auto'
  },
  flex: {
    md: '1'
  },
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  cursor: 'pointer'
};
var headerBoxStyle = {
  padding: 'md',
  display: 'flex',
  alignItems: 'center'
};
var contentBoxStyle = {
  background: 'baseWhite',
  gap: 'md',
  borderBottomRadius: 4,
  display: 'flex',
  flexDirection: 'column',
  flex: 1
};